<form [formGroup]="adminService.entity">
  <div class="grid">
    <div class="col-12">
      <div class="field">
        <label for="role">
          <span class="p-error">*</span>Rol:
        </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown formControlName="role" [panelStyle]="{'width': '100%' }" [style]="{'height': '45px'}" scrollHeight="150px" [options]="adminService.roles" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="Selecciona un rol">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="adminService.entity.get('role')?.value">
                <div>{{adminService.getRoleName(adminService.entity.get('role')?.value)}}</div>
              </div>
            </ng-template>
            <ng-template let-role pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ role.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <ng-container *ngIf="adminService.entity.get('role')?.invalid && (adminService.entity.get('role')?.dirty || adminService.entity.get('role')?.touched)">
            <small class="p-error" *ngIf="adminService.entity.get('role')?.errors?.['required']">El rol es obligatorio.</small>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Cuelga del rol elegido, no del guardado: solo un Admin puede votar en el Comité (ADR-0013). -->
    <div class="col-12" *ngIf="adminService.formMethod === 'EDIT' && adminService.isAdminRoleSelected">
      <div class="field">
        <div class="field-checkbox">
          <p-checkbox id="isCommitteeMember" formControlName="isCommitteeMember" [binary]="true"></p-checkbox>
          <label for="isCommitteeMember">Miembro del Comité de Aprobaciones</label>
        </div>
        <small class="text-600">Solo los marcados aparecen como votantes elegibles al abrir una reunión de Comité.</small>
      </div>
    </div>
    <div class="col-12" *ngIf="adminService.formMethod === 'EDIT'">
      <div class="field">
        <label for="status">
          <span class="p-error">*</span>Estatus:
        </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown formControlName="status" [panelStyle]="{'width': '100%' }" [style]="{'height': '45px'}" scrollHeight="150px" [options]="adminService.statuses" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="Selecciona un estatus">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="adminService.entity.get('status')?.value">
                <div>{{adminService.getStatusName(adminService.entity.get('status')?.value)}}</div>
              </div>
            </ng-template>
            <ng-template let-status pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ status.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <ng-container *ngIf="adminService.entity.get('status')?.invalid && (adminService.entity.get('status')?.dirty || adminService.entity.get('status')?.touched)">
            <small class="p-error" *ngIf="adminService.entity.get('status')?.errors?.['required']">El estatus es obligatorio.</small>
          </ng-container>
        </div>
      </div>
     </div>
    <div class="col-12">
      <div class="field">
        <label for="names">
          <span class="p-error">*</span>Nombre(s):
        </label>
        <input type="text" pInputText id="names" formControlName="names" placeholder="Nombre(s)" />
        <ng-container *ngIf="adminService.entity.get('names')?.invalid && (adminService.entity.get('names')?.dirty || adminService.entity.get('names')?.touched)">
          <small class="p-error" *ngIf="adminService.entity.get('names')?.errors?.['required']">El nombre es obligatorio.</small>
          <small class="p-error" *ngIf="adminService.entity.get('names')?.errors?.['pattern']">El nombre debe ser una cadena de texto válida.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field">
        <label for="lastNames">
          <span class="p-error">*</span>Apellidos:
        </label>
        <input type="text" pInputText id="lastNames" formControlName="lastNames" placeholder="Apellidos" />
        <ng-container *ngIf="adminService.entity.get('lastNames')?.invalid && (adminService.entity.get('lastNames')?.dirty || adminService.entity.get('lastNames')?.touched)">
          <small class="p-error" *ngIf="adminService.entity.get('lastNames')?.errors?.['required']">Los apellidos son obligatorios.</small>
          <small class="p-error" *ngIf="adminService.entity.get('lastNames')?.errors?.['pattern']">Los apellidos deben ser una cadena de texto válida.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="field">
        <label for="email">
          <span class="p-error">*</span>Correo Electrónico:
        </label>
        <input type="text" pInputText id="email" formControlName="email" placeholder="correo@rendafin.com" />
        <ng-container *ngIf="adminService.entity.get('email')?.invalid && (adminService.entity.get('email')?.dirty || adminService.entity.get('email')?.touched)">
          <small class="p-error" *ngIf="adminService.entity.get('email')?.errors?.['required']">El correo electrónico es obligatorio.</small>
          <small class="p-error" *ngIf="adminService.entity.get('email')?.errors?.['email']">El formato del correo electrónico es inválido.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12" *ngIf="adminService.formMethod === 'CREATE'">
      <div class="field">
        <small class="text-color-secondary">
          La contraseña se asigna automáticamente y se envía al correo del usuario. Se le pedirá cambiarla en su primer ingreso.
        </small>
      </div>
    </div>
  </div>
</form>
